<template>
  <div
    class="form-check form-check-radio"
    :class="[inlineClass, { disabled: disabled }]"
  >
    <label :for="cbId" class="form-check-label">
      <input
        :id="cbId"
        class="form-check-input"
        type="radio"
        :disabled="disabled"
        :value="value"
        :name="name"
        v-model="modelValue"
        @input="onUpdated"
        @click="onClick"
      />
      <slot></slot> <span class="form-check-sign"></span>
    </label>
  </div>
</template>
<script>
export default {
  name: 'base-radio',
  props: {
    name: {
      type: [String, Number],
      description: 'Radio label',
    },
    disabled: {
      type: Boolean,
      description: 'Whether radio is disabled',
    },
    value: {
      type: [String, Boolean],
      description: 'Radio value',
    },
    inline: {
      type: Boolean,
      description: 'Whether radio is inline',
    },
    modelValue: {
      type: [String, Boolean],
      description: 'Radio value',
    },
    unChecked: {
      type: Function,
      description: '取消选中执行的方法',
    },
  },
  emits: ['update:modelValue', 'change'],
  data() {
    return {
      cbId: '',
    };
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    inlineClass() {
      if (this.inline) {
        return `form-check-inline`;
      }
      return '';
    },
  },
  created() {
    this.cbId = Math.random().toString(16).slice(2);
  },
  setup(props, { emit }) {
    function onUpdated(e) {
      const oldValue = props.modelValue;

      if (oldValue !== e.currentTarget.value) {
        emit('update:modelValue', e.currentTarget.value);
        emit('change');
      }
    }

    function onClick(e) {
      if (props.modelValue === e.currentTarget.value && props.unChecked) {
        props.unChecked();
      }
    }

    return {
      onUpdated,
      onClick,
    };
  },
};
</script>
